import React, { useMemo } from "react";
import "./Projects.css";

// ✅ Import your local images
import session1 from "../assets/session1.jpg";
import session2 from "../assets/session2.jpg";

const PROJECTS = [
  {
    id: 1,
    tag: "COMPLETED",
    title: "Life Science Center",
    desc: "This project was successfully completed against an extremely tight programme.",
    image: session1,
  },
  {
    id: 2,
    tag: "RENOVATION",
    title: "Home building renovation",
    desc: "This project was successfully completed against an extremely tight programme.",
    image: session2,
  },
];

export default function Projects() {
  const projects = useMemo(() => PROJECTS, []);

  return (
    <section className="projectsPage">
      <div className="projectsInner">
        {/* ✅ Header */}
        <header className="projectsHeader">
          <p className="projectsKicker">COMPANY PROJECTS</p>
          <h1 className="projectsTitle">Projects Completed</h1>
          <div className="projectsLine" aria-hidden="true" />
        </header>

        {/* ✅ Alternating rows */}
        <div className="projectsRows" aria-label="Company projects list">
          {projects.map((p, idx) => {
            const isReverse = idx % 2 === 1; // 2nd row reverse
            return (
              <article
                key={p.id}
                className={`projRow ${isReverse ? "isReverse" : ""}`}
              >
                {/* Image */}
                <div className="projMedia" aria-label={`${p.title} image`}>
                  <img
                    src={p.image}
                    alt={p.title}
                    className="projImg"
                    loading="lazy"
                  />
                  <span className="projTag">{p.tag}</span>
                </div>

                {/* Content */}
                <div className="projContent">
                  <h3 className="projTitle">{p.title}</h3>
                  <p className="projDesc">{p.desc}</p>
                </div>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}
